import React, { Fragment } from 'react'
import cx from 'classnames'
import { injectIntl } from 'sb-react-intl'
import { useCallback } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import actions from 'redux/actions'
import { constants, snowplow } from 'common/helpers'

import { ReactComponent as HamburgerIcon } from 'components/_new/ui/Icon/images/nav/hamburger.svg'
import { ReactComponent as CloseIcon } from 'components/_new/ui/Icon/images/nav/close.svg'


import SidebarNav from './SidebarNav/SidebarNav'

import messages from './messages'
import s from './HamburgerButton.scss'


const HamburgerButton = ({ intl, className, onOpen }) => {
  const { isOpened, userLoggedIn } = useConnect({
    isOpened: 'models.ui.isSideMenuVisible',
    userLoggedIn: 'models.me.isLoggedIn',
  })

  const handleClick = useCallback(() => {
    if (isOpened) {
      actions.models.ui.closeSideMenu()
      return
    }

    actions.models.ui.openSideMenu()
    snowplow.track(constants.snowplowEvents.burgerMenuClick, {
      userLoggedIn: userLoggedIn ? 'yes' : 'no',
    })

    if (typeof onOpen === 'function') {
      onOpen('burger')
    }
  }, [ isOpened, onOpen, userLoggedIn ])

  return (
    <Fragment>
      <button
        className={cx(s.button, className)}
        type="button"
        aria-label={intl.formatMessage(messages.mainMenu)}
        onClick={handleClick}
      >
        <HamburgerIcon className={cx(s.icon, { [s.active]: !isOpened })} />
        <CloseIcon className={cx(s.icon, { [s.active]: isOpened })} />
      </button>
      <SidebarNav />
    </Fragment>
  )
}


export default injectIntl(HamburgerButton)
